
import { defineComponent, computed, ref, onBeforeMount } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Popup, Toast } from 'vant'
import { Device } from '@loca/mfe-vue3'
import CellSelect from '@/components/CellSelect/index.vue'
import { HeaderUtils, HeaderOption } from './HeaderUtils'
import { tabbarRoutes } from '../Layout/mobileTabbarListConfig'
import { Env } from '@loca/mfe-vue3'
import { dictApis } from '@/apis'
import { handleTransferMessage, getMessageManager } from '@/utils/feishuBridge'

const KEY_FIRST_PAGE = '__POWER-GO-MAIN__FIRST-PAGE__'

export default defineComponent({
  name: 'LayoutComp',

  components: {
    'van-popup': Popup,
    CellSelect,
  },

  props: {
    showBorder: { type: Boolean, default: false },
    fixed: { type: Boolean, default: false },
    sticky: { type: Boolean, default: false },
  },
  setup(props) {
    const route = useRoute()
    const router = useRouter()

    const isMobile = Device.isMobile()
    const titleDefault = 'NPDS'
    const title = ref(titleDefault)
    const titleOptions = ref<HeaderOption[]>([])
    const titleSelected = ref<HeaderOption | null>(null)
    const titleChangeCallback = ref<any>(null)
    const showTitleOptions = ref(false)
    const showTitleOptionsWrapper = ref(false)

    const showBackBtn = computed(() => {
      if (!isMobile) return true

      const { showBack } = route.meta
      if (typeof showBack === 'boolean') return showBack

      return !tabbarRoutes.includes(route.path)
    })
    let fullPath = sessionStorage.getItem(KEY_FIRST_PAGE)
    // 监听 document.title 变化，同时变更自定义导航标题
    function observeTitle() {
      const target = document.head.querySelector('title')
      const config = { childList: true }
      const observer = new MutationObserver(() => {
        title.value = document.title
      })
      observer.observe(target!, config)

      title.value = document.title || titleDefault
    }
    function isFirstPage() {
      const historyLen = window.history.length
      fullPath = sessionStorage.getItem(KEY_FIRST_PAGE)
      return historyLen === 1 || fullPath === window.location.href
    }
    function handleBack() {
      if (isMobile && isFirstPage()) {
        window.history.replaceState({}, '', '/')
      } else {
        router.back()
      }
    }

    function testBridge() {
      const manager = getMessageManager()
      manager?.onTransferMessage?.((res) => {
        console.log('onTransferMessage', res)
      })
      manager?.transferMessage({ data: { action: 'getLocation' }, success: (res) => {
          console.log('success', res)
        },
        fail: (res) => {
          console.log('fail', res)
        },
      })
    }
    function toggleTitleOptions(flag?: boolean) {
      showTitleOptions.value = typeof flag === 'boolean' ? flag : !showTitleOptions.value
    }

    function toggleTitleOptionsWrapper(flag?: boolean) {
      const res = typeof flag === 'boolean' ? flag : !showTitleOptionsWrapper.value
      showTitleOptionsWrapper.value = res
    }
    function handleTitleOptionChange(option: any) {
      toggleTitleOptions(false)
      if (typeof titleChangeCallback.value === 'function') {
        titleChangeCallback.value(option)
      }
    }
    if (!fullPath) {
      sessionStorage.setItem(KEY_FIRST_PAGE, window.location.href)
    }
    observeTitle()

    HeaderUtils.onTitleOptionsChange((payload: any) => {
      if (payload === false) {
        titleOptions.value = []
        titleSelected.value = null
        titleChangeCallback.value = null
      } else {
        const { options, defaultIndex, callback } = payload
        titleOptions.value = options ? [...options] : []
        titleSelected.value = titleOptions.value[defaultIndex] || titleOptions.value[0]
        titleChangeCallback.value = callback
      }
    })

    // 左侧自定义内容
    const leftContentConfig = ref<{ text: string; onClick?: () => void } | null>(null)

    const leftBackConfig = ref<{ onClick?: () => void } | null>(null)

    HeaderUtils.onLeftBackChange((config: any) => {
      leftBackConfig.value = config
    })

    HeaderUtils.onLeftContentChange((config: any) => {
      leftContentConfig.value = config
    })

    const rightVisible = ref(false)
    HeaderUtils.onRightVisibleChange((visible: boolean) => {
      rightVisible.value = visible
    })

    const handleLeftContentClick = () => {
      if (leftContentConfig.value?.onClick) {
        leftContentConfig.value.onClick()
      }
    }

    const handleLeftBackClick = () => {
      if (leftBackConfig.value?.onClick) {
        leftBackConfig.value.onClick()
      } else {
        handleBack()
      }
    }

    const dictInfo: any = ref({})
    const isProd = computed(() => {
      let env = Env.getEnv()
      return ['prod', 'stg'].includes(env)
    })
    const warningInfo = computed(() => {
      let env = Env.getEnv()
      let text = dictInfo.value?.npds_header_global_warning?.[env] || ''
      let arr = text.split('---')
      if (Array.isArray(arr) && arr.length > 1) {
        return {
          env: arr[0],
          desc: arr[1],
        }
      } else {
        return { env: '-', desc: '-' }
      }
    })

    async function getDictConfig() {
      try {
        const dictInfoTemp = {}
        const dictTypes = ['npds_header_global_warning']
        let res = await dictApis.getDict(dictTypes)
        if (res?.data) {
          Object.keys(res?.data).forEach((prop) => {
            let dictItem = res?.data?.[prop] || []
            dictInfoTemp[prop] = dictItem.reduce((result, item) => {
              result[item.code] = item.name
              return result
            }, {})
          })
          dictInfo.value = dictInfoTemp
        }
      } catch (e) {}
    }

    onBeforeMount(async () => {
      getDictConfig()
    })

    return {
      isMobile,
      showBackBtn,
      titleOptions,
      title,
      titleSelected,
      showTitleOptions,
      showTitleOptionsWrapper,
      warningInfo,
      isProd,
      handleBack,
      toggleTitleOptions,
      handleTitleOptionChange,
      toggleTitleOptionsWrapper,
      leftContentConfig,
      handleLeftContentClick,
      leftBackConfig,
      handleLeftBackClick,
      rightVisible,
      testBridge,
    }
  },
})
